<div class="modal-content bary-add-transport-incident">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4">{{ 'modals.addTransportIncident.title' | translate }}</p>
  </div>
  <div class="modal-body" *ngIf="incidentForm">
    <div class="mx-2 alert alert-info">
      {{ 'modals.addTransportIncident.info' | translate }}
    </div>
    <div class="mx-2 alert alert-warning" *ngIf="!incidentItemsOptions || incidentItemsOptions.length === 0">
      {{ 'modals.addTransportIncident.noOptions' | translate }}
    </div>
    <form [formGroup]="incidentForm" class="d-flex flex-column">
      <jhi-bary-input-select
        [id]="'addTransportIncident.input.cause'"
        [label]="'modals.addTransportIncident.input.cause' | translate"
        [control]="getControl('cause')"
        [options]="incidentItemsOptions"
      >
      </jhi-bary-input-select>
      <div class="d-flex flex-row">
        <div class="d-flex flex-column mr-2 'w-50'">
          <div class="d-flex flex-row align-items-center">
            <jhi-bary-input-price [control]="getControl('incidentAmount')" [label]="'modals.addTransportIncident.input.amount' | translate"> </jhi-bary-input-price>
            <span class="d-flex flex-row align-items-center">
              <jhi-bary-input-switch id="input-checkbox-hasGazoleTax" class="flex-grow-1" [control]="getControl('hasGazoleTax')"> </jhi-bary-input-switch>
              {{ 'modals.addTransportIncident.input.hasGazoleTax' | translate }}
            </span>
          </div>
          <jhi-bary-input-textarea [control]="getControl('comment')" [maxLength]="150" [label]="'modals.addTransportIncident.input.comment' | translate"></jhi-bary-input-textarea>
        </div>
        <jhi-estimation-price
          class="ml-3 w-50"
          keyLabelBasePrice="modals.addTransportIncident.labels.priceHT"
          [showButton]="false"
          [lastEstimate]="estimationInfo"
        ></jhi-estimation-price>
      </div>
    </form>
  </div>

  <div class="modal-footer justify-content-end" *ngIf="incidentItemsOptions && incidentItemsOptions.length > 0">
    <jhi-bary-button
      [outline]="true"
      color="primary"
      class="mr-2"
      [label]="'modals.addTransportIncident.cancel' | translate"
      (clickEvent)="handleClick({ cancel: true })"
    ></jhi-bary-button>
    <jhi-bary-button (clickEvent)="submit()" [label]="'modals.addTransportIncident.submit' | translate" color="primary" [disabled]="incidentForm.invalid"></jhi-bary-button>
  </div>
</div>
